import React from "react";
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { Editor } from "primereact/editor";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";

import { FormSectionElements } from "../../entities/formTemplateDataType";

interface Props {
	ele: FormSectionElements;
	dialogVisible: boolean;
	isEng: boolean;
	callback;
}
interface State {
}

export class DialogForIncidentReportConfirmationComponent extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
		};
	}

	componentDidMount(): void {
	}

	generateHtmlString = () => {
		let html = [];
		html.push(
			<>
				<Dialog header={this.props.isEng ? "Field Properties for " + this.props.ele.ENUTitle : "Field Properties for " + this.props.ele.FRATitle} footer={this.renderFooter()}
					visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
					{this.incidentReportConfirmationHtml()}
				</Dialog>
			</>
		);
		return html;
	}

	incidentReportConfirmationHtml = () => {
		let htmlString = [];
		htmlString.push(
			<div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Page Title</div>
					<div style={{ width: '60%' }}>
						<InputText className="ontario-input" value={this.props.isEng ? this.props.ele.ENUTitle : this.props.ele.FRATitle} onChange={(e) => {
							if (this.props.isEng) {
								this.props.ele.ENUTitle = e.target.value;
							} else {
								this.props.ele.FRATitle = e.target.value;
							}
							this.props.callback();
						}} />
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Success Message Title</div>
					<div style={{ width: '60%' }}>
						<InputText className="ontario-input" value={this.props.isEng ? this.props.ele.callOutBoxTitle : this.props.ele.callOutBoxTitleFRA} onChange={(e) => {
							if (this.props.isEng) {
								this.props.ele.callOutBoxTitle = e.target.value;
							} else {
								this.props.ele.callOutBoxTitleFRA = e.target.value;
							}
							this.props.callback();
						}} />
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Success Message Body</div>
					<div style={{ width: '60%' }}>
						<Editor className="ontario-input" value={this.props.isEng ? this.props.ele.ErrorMessageRichText : this.props.ele.ErrorMessageRichTextFRA} onTextChange={(e) => {
							if (this.props.isEng) {
								this.props.ele.ErrorMessageRichText = e.htmlValue;
							} else {
								this.props.ele.ErrorMessageRichTextFRA = e.htmlValue;
							}
							this.props.callback();
						}} />
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Button 1 Label</div>
					<div style={{ width: '60%' }}>
						<InputText className="ontario-input" value={this.props.isEng ? this.props.ele.TooltipENU : this.props.ele.TooltipFRA} onChange={(e) => {
							if (this.props.isEng) {
								this.props.ele.TooltipENU = e.target.value;
							} else {
								this.props.ele.TooltipFRA = e.target.value;
							}
							this.props.callback();
						}} />
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px', marginBottom: '20px' }}>
					<div style={{ width: '25%' }}>
						<label htmlFor={"button1_url"}>Button 1 URL (Submit Another)</label>
					</div>
					<div style={{ width: '60%' }}>
						<InputText key={"button1_url"} value={this.props.isEng ? this.props.ele.BackUrl : this.props.ele.BackUrlFRA} className="ontario-input"
							onChange={(e) => {
								if (this.props.isEng) {
									this.props.ele.BackUrl = e.target.value;
								} else {
									this.props.ele.BackUrlFRA = e.target.value;
								}
								this.props.callback();
							}} />
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Button 2 Label</div>
					<div style={{ width: '60%' }}>
						<InputText className="ontario-input" value={this.props.isEng ? this.props.ele.callOutBoxBody : this.props.ele.callOutBoxBodyFRA} onChange={(e) => {
							if (this.props.isEng) {
								this.props.ele.callOutBoxBody = e.target.value;
							} else {
								this.props.ele.callOutBoxBodyFRA = e.target.value;
							}
							this.props.callback();
						}} />
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px', marginBottom: '20px' }}>
					<div style={{ width: '25%' }}>
						<label htmlFor={"button2_url"}>Button 2 URL (View All)</label>
					</div>
					<div style={{ width: '60%' }}>
						<InputText key={"button2_url"} value={this.props.isEng ? this.props.ele.FeedbackURL : this.props.ele.FeedbackURLFRA} className="ontario-input"
							onChange={(e) => {
								if (this.props.isEng) {
									this.props.ele.FeedbackURL = e.target.value;
								} else {
									this.props.ele.FeedbackURLFRA = e.target.value;
								}
								this.props.callback();
							}} />
					</div>
				</div>

				{/* Submitted Reports Table Section */}
				<div style={{ marginTop: '20px', borderTop: '1px solid #ddd', paddingTop: '15px' }}>
					<strong>Submitted Reports Table</strong>
				</div>
				<div style={{ display: "flex", alignItems: 'center', marginTop: '10px' }}>
					<div style={{ width: '25%' }}>
						<label htmlFor={"show_submitted_table"}>Show Submitted Table</label>
					</div>
					<div style={{ width: '60%' }}>
						<Checkbox
							inputId={"show_submitted_table"}
							checked={this.props.ele.ShowSubmittedTable || false}
							onChange={(e) => {
								this.props.ele.ShowSubmittedTable = e.checked;
								this.props.callback();
							}}
						/>
					</div>
				</div>
				{this.props.ele.ShowSubmittedTable && (
					<>
						<div style={{ display: "flex", marginTop: '10px' }}>
							<div style={{ width: '25%' }}>
								<label htmlFor={"dynamic_title_en"}>Dynamic Title (EN)</label>
							</div>
							<div style={{ width: '60%' }}>
								<InputText
									id={"dynamic_title_en"}
									className="ontario-input"
									value={this.props.ele.DynamicTitleEN || ''}
									placeholder="{count} incident reports were successfully submitted"
									onChange={(e) => {
										this.props.ele.DynamicTitleEN = e.target.value;
										this.props.callback();
									}}
								/>
								<small style={{ color: '#666' }}>Use {'{count}'} as placeholder for the number of reports</small>
							</div>
						</div>
						<div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
							<div style={{ width: '25%' }}>
								<label htmlFor={"dynamic_title_fr"}>Dynamic Title (FR)</label>
							</div>
							<div style={{ width: '60%' }}>
								<InputText
									id={"dynamic_title_fr"}
									className="ontario-input"
									value={this.props.ele.DynamicTitleFR || ''}
									placeholder="{count} rapports d'incident ont été soumis avec succès"
									onChange={(e) => {
										this.props.ele.DynamicTitleFR = e.target.value;
										this.props.callback();
									}}
								/>
								<small style={{ color: '#666' }}>Utilisez {'{count}'} comme espace réservé pour le nombre de rapports</small>
							</div>
						</div>
					</>
				)}
			</div>
		)
		return htmlString;
	}

	renderFooter = () => {
		return (
			<div>
				<Button label="OK" icon="pi pi-check" onClick={() => {
					this.props.callback(false);
				}} />
				<Button label="Cancel" onClick={() => { this.props.callback(false) }} />
			</div>
		);
	}

	render() {
		return (
			this.generateHtmlString()
		)
	}
}